import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CMSService } from '../../../../services/cms-service';
import { MedicamentLivre } from 'model/modal-cms/medicament_livre';

@Component({
  selector: 'app-view-medicament-livrer',
  templateUrl: './view-medicament-livrer.component.html',
  styleUrls: ['./view-medicament-livrer.component.scss']
})

export class ViewMedicamentLivrerComponent implements OnInit {  
  libelle:any="Consomable pharmacie, ";
  lieu:any="Tsiazotafo"
  pdfSrc: string = "";
  id_med_livrer: any;
  medicamentLivre : MedicamentLivre=new MedicamentLivre(null);
  constructor(private router: Router, public activatedRoute: ActivatedRoute,public cmsService: CMSService) { 
    this.id_med_livrer = activatedRoute.snapshot.params['id'];
  }

  ngOnInit() {
    this.getDetailMedlivrer();
  }

  return(){
    this.router.navigate(['med-livre']);  
  }


  getDetailMedlivrer() {
    this.cmsService.getMedLivrerDetail(this.id_med_livrer)
      .subscribe(data => {
        this.medicamentLivre = data
        this.pdfSrc = this.medicamentLivre.file_med_liv
      },
        err => {
          console.log(err);
        })
  }




}
